import React from 'react'

export default function Pagination({ page, totalPages, onPageChange }) {
    if (totalPages <= 1) return null;

    const maxVisible = 3;
    const start = Math.floor((page - 1) / maxVisible) * maxVisible + 1;
    const end = Math.min(start + maxVisible - 1, totalPages);
    const pageNumbers = Array.from({ length: end - start + 1 }, (_, i) => start + i);

    return (
        <nav className="mt-4" aria-label="Pagination">
            <ul className="pagination justify-content-center">
                <li className={`page-item ${start <= 1 ? "disabled" : ""}`}>
                    <button className="page-link" onClick={() => onPageChange(start - 1)} disabled={start <= 1} aria-label="Previous">
                        <span aria-hidden="true">&laquo;</span>
                    </button>
                </li>
                {pageNumbers.map((p) => (
                    <li key={p} className={`page-item ${p === page ? "active" : ""}`}>
                        <button className="page-link" onClick={() => onPageChange(p)}>{p}</button>
                    </li>
                ))}
                <li className={`page-item ${end >= totalPages ? "disabled" : ""}`}>
                    <button className="page-link" onClick={() => onPageChange(end + 1)} disabled={end >= totalPages} aria-label="Next">
                        <span aria-hidden="true">&raquo;</span>
                    </button>
                </li>
            </ul>
        </nav>
    )
}
